<template>
  <LazyHomeCommonLayout>
    <template #content>
      <LazyHomePricingCheckout :plan="plan" :billing="billing" />
    </template>
  </LazyHomeCommonLayout>
</template>

<script setup lang="ts">
import { useUserStore } from "~/store/user/userStore";
import { SignType, SignUIType } from "~/components/Sign/enum/SignType";
import { UserOrgSettingsMenuType } from "~/components/User/Settings/Common/model/UserOrgSettingsMenuType";

useHead({
  title: "Checkout | Codepresso",
  meta: [
    { name: "robots", content: "noindex,nofollow" }
  ]
});

definePageMeta({
  ssr: false,
});

const route = useRoute();
const router = useRouter();
const userStore = useUserStore();

const plan = computed(() => (route.query.plan as string) || "basic");
const billing = computed(() => (route.query.billing as string) || "annual");

// PAY-SUB-14: Get Started 가드(로그인 → 조직 → 기존 구독 → 최고관리자) 후 결제 페이지 진입.
const runGuards = () => {
  if (userStore.isLogOut()) {
    router.replace({ path: '/sign', query: { uiType: SignUIType.LOGIN, type: SignType.CANDIDATE } });
    return;
  }
  if (!userStore.userV2.orgInfo?.orgName) {
    router.replace({ path: '/settings/org'} )
    return;
  }
  if (userStore.subscription) {
    router.replace({ path: '/settings/org', query: { tab: UserOrgSettingsMenuType.PAYMENT }} )
    return;
  }
  if (!userStore.isSuperAdminType) {
    router.replace({ path: '/home/pricing' });
  }
};

onMounted(() => {
  if (userStore.isAuthResolved) {
    runGuards();
    return;
  }

  const stop = watch(() => userStore.isAuthResolved, (resolved) => {
    if (resolved) {
      stop();
      runGuards();
    }
  });
});
</script>

<style>
@import "~/assets/scss/main_style.scss";
</style>
